module.exports = __webpack_public_path__ + "img/fb.aa619859.svg";